module.exports = __webpack_public_path__ + "img/riviera.53f1e117.png";